import { IEntryInLeague } from "core-integration/src/store/leagues/types";
import { FilterChip } from "plos/src/components/Chip";
import { FilterRadioButton } from "plos/src/components/FilterSheet";
import FilterFooter from "plos/src/components/FilterSheet/FilterFooter";
import {
  contentStyles,
  filterButtonGroupWrapper,
} from "plos/src/components/FilterSheet/FilterRadioButton/filterRadioButton.css";
import { RadioButtonGroup } from "plos/src/components/forms";
import { Sheet } from "plos/src/components/Sheet";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getSelectedOption } from "../../utils";

interface EntryFilterProps {
  selectedEntryId: number;
  entries: IEntryInLeague[];
  handleFilterChange: (entryId: number) => void;
}

const EntryFilter = ({
  selectedEntryId,
  entries,
  handleFilterChange,
}: EntryFilterProps) => {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [unsavedSelectionId, setUnsavedSelectionId] = useState<
    string | undefined
  >(undefined);

  const entryIdAsString = selectedEntryId.toString();

  const formattedLeagueEntries = [
    { value: "0", label: t("allTeams", "All Teams") },
    ...entries.map(({ entry, entry_name: name }) => ({
      value: entry.toString(),
      label: name,
    })),
  ];

  const selectedEntry = getSelectedOption({
    filterOptions: formattedLeagueEntries,
    selectedOption: selectedEntryId,
  });

  const handleClose = () => {
    setOpen(false);
    setUnsavedSelectionId(undefined);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const isSaveButtonDisabled =
    unsavedSelectionId == null || entryIdAsString == unsavedSelectionId;

  const handleSave = () => {
    if (!unsavedSelectionId) return;
    handleFilterChange(parseInt(unsavedSelectionId, 10));
    setUnsavedSelectionId(undefined);
    handleClose();
  };

  return (
    <>
      <FilterChip
        label={t("team", "Team")}
        selectedOption={[selectedEntry]}
        onClick={handleOpen}
      />
      <Sheet
        headerSize="xl"
        title={t("teams", "Teams")}
        open={open}
        handleClose={handleClose}
        footer={
          <FilterFooter
            isDisabled={isSaveButtonDisabled}
            handleSave={handleSave}
            handleClose={handleClose}
          />
        }
      >
        <div className={filterButtonGroupWrapper}>
          <div className={contentStyles}>
            <RadioButtonGroup
              label={t("teams", "Teams")}
              value={unsavedSelectionId ?? entryIdAsString}
              onChange={(id) => setUnsavedSelectionId(id)}
              hideLabel
            >
              {formattedLeagueEntries.map(({ value, label }) => (
                <FilterRadioButton key={value} value={value}>
                  {label}
                </FilterRadioButton>
              ))}
            </RadioButtonGroup>
          </div>
        </div>
      </Sheet>
    </>
  );
};
export default EntryFilter;
